import React from "react";
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import { Message } from "semantic-ui-react";
import ProgressCard from "../../Initiatives/Drive/cards/ProgressCard";
import { Grid } from 'semantic-ui-react'
import LoadingComponent from '../../../common/LoadingComponent';
import BreadCrumbsCard from "../Drive/Cards/Breadcrumb";

class InitiativeActivities extends React.Component {

	componentWillMount() {
		this.setInitiative()
		dispatch.app.setCollapsedResourcePaneIndex(null)
		this.setActivity()
		dispatch.initiatives.setTabName(this.props.match.params.myactivities);
	}

	setInitiative() {
		if (this.props.match.params.initiativeId) {
			dispatch.initiatives.setInitiativeId(this.props.match.params.initiativeId);
			dispatch.initiatives.getActiveInitiativeDetailsById({ initiativeId: this.props.match.params.initiativeId, isMemberView: true });
		}
		else {
			dispatch.initiatives.setInitiativeId(null);
		}
	}

	setActivity() {
		if (this.props.match.params.workspaceId) {
			let payload = {
				organizationId: this.props.match.params.workspaceId,
				userId: this.props.user._id,
				raciAllChecked: true
			}
			dispatch.initiatives.getInitiativeActivitiesForMember(payload);
		}
	}


	async componentWillReceiveProps(nextProps) {
		if ((nextProps.match.params && nextProps.match.params.workspaceId && nextProps.match.params.initiativeId && nextProps.match.params.initiativeId !== this.props.match.params.initiativeId) ||
			(nextProps.match.params && nextProps.match.params.workspaceId && nextProps.match.params.initiativeStatus !== this.props.match.params.initiativeStatus)) {
			this.setActivity()
		}
	}

	render() {

		let noInitiativeMessage = false;
		if (this.props.match.params.initiativeId === this.props.selectedDataById._id && this.props.selectedDataById && this.props.selectedDataById.status === 3) {
			noInitiativeMessage = true;

		} else {
			noInitiativeMessage = false;
		}
		const { initiativeMemberActivities, loadingMyActivities } = this.props;

		return (
			<div className="w_100 pad_20" >
				<Grid className="initiative_overall_progress w_100" >
					<Grid.Row className="pad_0">
						<BreadCrumbsCard {...this.props} />
						{noInitiativeMessage ?
							<span className="w_100" style={{ 'margin-bottom': '0px', 'margin-top': '-10px' }}>
								{noInitiativeMessage ? <Message fluid content="This initiative has been closed" warning className="mar_10	" /> : null}
							</span> : ''
						}
						{loadingMyActivities ?
							<LoadingComponent active={loadingMyActivities}
								message="Fetching Initiative Activities"
							/> :
							<ProgressCard activityNodes={initiativeMemberActivities.myActivities} {...this.props} noInitiativeMessage={noInitiativeMessage} />
						}
					</Grid.Row>
				</Grid>
			</div>
		);
	}
}


export default withRouter(InitiativeActivities);
